import { graphql } from "../../gql";

export const LIBRARY_IMAGES_QUERY = graphql(`
  query LibraryImageAll {
    libraryImageAll {
      ...LIBRARY_IMAGE_FIELDS
    }
  }
`);
